import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
};

export type DatasetSchema = {
  __typename?: 'DatasetSchema';
  schema?: Maybe<Scalars['JSON']['output']>;
};

export type ExportCsvDownloadUrlResult = {
  __typename?: 'ExportCsvDownloadUrlResult';
  downloadUrl: Scalars['String']['output'];
};

export type HelpArticle = {
  __typename?: 'HelpArticle';
  assets: Array<HelpAsset>;
  category: Scalars['String']['output'];
  markdown: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HelpArticleSummary = {
  __typename?: 'HelpArticleSummary';
  category: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HelpAsset = {
  __typename?: 'HelpAsset';
  filename: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HelpFileManifestInput = {
  byteSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  mediaType: Scalars['String']['input'];
  sha256: Scalars['String']['input'];
};

export type HelpPublishResult = {
  __typename?: 'HelpPublishResult';
  article: HelpArticle;
};

export type HelpUpload = {
  __typename?: 'HelpUpload';
  expiresAt: Scalars['DateTime']['output'];
  targets: Array<HelpUploadTarget>;
  uploadId: Scalars['ID']['output'];
};

export type HelpUploadTarget = {
  __typename?: 'HelpUploadTarget';
  checksumSha256?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
  requiresAuth: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  invalidateMyTransformationCaches: Scalars['Int']['output'];
  prepareMyHelpArticleUpload: HelpUpload;
  publishMyHelpArticle: HelpPublishResult;
  setMyRunName: Scalars['String']['output'];
  unpublishMyHelpArticle: Scalars['Boolean']['output'];
};


export type MutationInvalidateMyTransformationCachesArgs = {
  runSettings: RunSettingsInput;
};


export type MutationPrepareMyHelpArticleUploadArgs = {
  input: PrepareHelpArticleUploadInput;
};


export type MutationPublishMyHelpArticleArgs = {
  uploadId: Scalars['ID']['input'];
};


export type MutationSetMyRunNameArgs = {
  name: Scalars['String']['input'];
  runSettings: RunSettingsInput;
};


export type MutationUnpublishMyHelpArticleArgs = {
  slug: Scalars['String']['input'];
};

export type PrepareHelpArticleUploadInput = {
  category: Scalars['String']['input'];
  files: Array<HelpFileManifestInput>;
  slug: Scalars['String']['input'];
  summary: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  getExportCsvDownloadUrl?: Maybe<ExportCsvDownloadUrlResult>;
  getMatrixSortKeys?: Maybe<Scalars['String']['output']>;
  getMyRunTrendSeries: Array<TrendPoint>;
  getRawParquet?: Maybe<Scalars['String']['output']>;
  getTransformedParquetDownloadUrl?: Maybe<TransformedParquetDownloadUrlResult>;
  hello: Scalars['String']['output'];
  myHelpArticle?: Maybe<HelpArticle>;
  myHelpArticles: Array<HelpArticleSummary>;
};


export type QueryGetExportCsvDownloadUrlArgs = {
  comparedToRunSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  datasetName: Scalars['String']['input'];
  downloadFilename?: InputMaybe<Scalars['String']['input']>;
  excludeDetailRows: Scalars['Boolean']['input'];
  folder: Scalars['String']['input'];
  measure?: InputMaybe<Scalars['String']['input']>;
  params: Scalars['JSON']['input'];
  runSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortConfig?: InputMaybe<Scalars['JSON']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  transformId: Scalars['String']['input'];
};


export type QueryGetMatrixSortKeysArgs = {
  comparedToRunSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  datasetName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  measure: Scalars['String']['input'];
  params: Scalars['JSON']['input'];
  runSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  transformId: Scalars['String']['input'];
};


export type QueryGetRawParquetArgs = {
  datasetName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  format: Scalars['String']['input'];
  setId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTransformedParquetDownloadUrlArgs = {
  comparedToRunSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  datasetName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  params: Scalars['JSON']['input'];
  runSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  transformId: Scalars['String']['input'];
};


export type QueryMyHelpArticleArgs = {
  slug: Scalars['String']['input'];
};

export type Run = {
  __typename?: 'Run';
  atStep?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initiatedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  runSettings: RunSettings;
  status: Scalars['String']['output'];
  stepIds: Scalars['String']['output'];
  totalSteps?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type RunProgress = {
  __typename?: 'RunProgress';
  atStep: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  engineInProgress: Scalars['Boolean']['output'];
  initiatedBy: Scalars['String']['output'];
  inputId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  runAttemptId: Scalars['String']['output'];
  settingsNameAndVersion: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stepIds: Scalars['String']['output'];
  totalSteps: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type RunSettings = {
  __typename?: 'RunSettings';
  inputId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  runAttemptId: Scalars['String']['output'];
  settingsNameAndVersion: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type RunSettingsInput = {
  inputId: Scalars['String']['input'];
  runAttemptId: Scalars['String']['input'];
  settingsNameAndVersion: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type Runs = {
  __typename?: 'Runs';
  engineInProgress: Scalars['Boolean']['output'];
  runs: Array<Run>;
};

export type Subscription = {
  __typename?: 'Subscription';
  getDatasetSchemaUpdates: DatasetSchema;
  getRuns: Runs;
  getTransformedRawParquet: TransformedParquetStatus;
  webappNotifications: RunProgress;
};


export type SubscriptionGetDatasetSchemaUpdatesArgs = {
  comparedToSetId?: InputMaybe<Scalars['String']['input']>;
  datasetName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  format: Scalars['String']['input'];
  lockedSetId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionGetTransformedRawParquetArgs = {
  comparedToRunSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  datasetName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  format: Scalars['String']['input'];
  params: Scalars['JSON']['input'];
  runSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  transformId: Scalars['String']['input'];
};

export enum TransformStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Loading = 'LOADING'
}

export type TransformedParquetDownloadUrlResult = {
  __typename?: 'TransformedParquetDownloadUrlResult';
  downloadUrl: Scalars['String']['output'];
  parquetRowCount?: Maybe<Scalars['Int']['output']>;
};

export type TransformedParquetStatus = {
  __typename?: 'TransformedParquetStatus';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  parquetData?: Maybe<Scalars['String']['output']>;
  parquetRowCount?: Maybe<Scalars['Int']['output']>;
  status: TransformStatusEnum;
};

export type TrendPoint = {
  __typename?: 'TrendPoint';
  excessRunCount: Scalars['Int']['output'];
  excessUnits?: Maybe<Scalars['Float']['output']>;
  inventoryRunCount: Scalars['Int']['output'];
  inventoryUnits?: Maybe<Scalars['Float']['output']>;
  month: Scalars['String']['output'];
  runCount: Scalars['Int']['output'];
  unfulfilledRunCount: Scalars['Int']['output'];
  unfulfilledUnits?: Maybe<Scalars['Float']['output']>;
};

export type InvalidateMyTransformationCachesMutationVariables = Exact<{
  runSettings: RunSettingsInput;
}>;


export type InvalidateMyTransformationCachesMutation = { __typename?: 'Mutation', invalidateMyTransformationCaches: number };

export type PrepareMyHelpArticleUploadMutationVariables = Exact<{
  input: PrepareHelpArticleUploadInput;
}>;


export type PrepareMyHelpArticleUploadMutation = { __typename?: 'Mutation', prepareMyHelpArticleUpload: { __typename?: 'HelpUpload', uploadId: string, expiresAt: any, targets: Array<{ __typename?: 'HelpUploadTarget', filename: string, mediaType: string, url: string, requiresAuth: boolean, checksumSha256?: string | null }> } };

export type PublishMyHelpArticleMutationVariables = Exact<{
  uploadId: Scalars['ID']['input'];
}>;


export type PublishMyHelpArticleMutation = { __typename?: 'Mutation', publishMyHelpArticle: { __typename?: 'HelpPublishResult', article: { __typename?: 'HelpArticle', slug: string, title: string, summary: string, category: string, markdown: string, updatedAt: any, assets: Array<{ __typename?: 'HelpAsset', filename: string, mediaType: string, url: string }> } } };

export type SetMyRunNameMutationVariables = Exact<{
  runSettings: RunSettingsInput;
  name: Scalars['String']['input'];
}>;


export type SetMyRunNameMutation = { __typename?: 'Mutation', setMyRunName: string };

export type UnpublishMyHelpArticleMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type UnpublishMyHelpArticleMutation = { __typename?: 'Mutation', unpublishMyHelpArticle: boolean };

export type GetExportCsvDownloadUrlQueryVariables = Exact<{
  datasetName: Scalars['String']['input'];
  transformId: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  runSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  comparedToRunSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  params: Scalars['JSON']['input'];
  measure?: InputMaybe<Scalars['String']['input']>;
  excludeDetailRows: Scalars['Boolean']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortConfig?: InputMaybe<Scalars['JSON']['input']>;
  downloadFilename?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExportCsvDownloadUrlQuery = { __typename?: 'Query', getExportCsvDownloadUrl?: { __typename?: 'ExportCsvDownloadUrlResult', downloadUrl: string } | null };

export type GetMatrixSortKeysQueryVariables = Exact<{
  datasetName: Scalars['String']['input'];
  transformId: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  runSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  comparedToRunSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  params: Scalars['JSON']['input'];
  measure: Scalars['String']['input'];
}>;


export type GetMatrixSortKeysQuery = { __typename?: 'Query', getMatrixSortKeys?: string | null };

export type GetMyRunTrendSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyRunTrendSeriesQuery = { __typename?: 'Query', getMyRunTrendSeries: Array<{ __typename?: 'TrendPoint', month: string, runCount: number, inventoryUnits?: number | null, unfulfilledUnits?: number | null, excessUnits?: number | null, inventoryRunCount: number, unfulfilledRunCount: number, excessRunCount: number }> };

export type GetRawParquetQueryVariables = Exact<{
  datasetName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  setId?: InputMaybe<Scalars['String']['input']>;
  format: Scalars['String']['input'];
}>;


export type GetRawParquetQuery = { __typename?: 'Query', getRawParquet?: string | null };

export type GetTransformedParquetDownloadUrlQueryVariables = Exact<{
  datasetName: Scalars['String']['input'];
  transformId: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  runSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  comparedToRunSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  params: Scalars['JSON']['input'];
}>;


export type GetTransformedParquetDownloadUrlQuery = { __typename?: 'Query', getTransformedParquetDownloadUrl?: { __typename?: 'TransformedParquetDownloadUrlResult', downloadUrl: string, parquetRowCount?: number | null } | null };

export type MyHelpArticleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type MyHelpArticleQuery = { __typename?: 'Query', myHelpArticle?: { __typename?: 'HelpArticle', slug: string, title: string, summary: string, category: string, markdown: string, updatedAt: any, assets: Array<{ __typename?: 'HelpAsset', filename: string, mediaType: string, url: string }> } | null };

export type MyHelpArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyHelpArticlesQuery = { __typename?: 'Query', myHelpArticles: Array<{ __typename?: 'HelpArticleSummary', slug: string, title: string, summary: string, category: string, updatedAt: any }> };

export type GetDatasetSchemaUpdatesSubscriptionVariables = Exact<{
  datasetName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  lockedSetId?: InputMaybe<Scalars['String']['input']>;
  comparedToSetId?: InputMaybe<Scalars['String']['input']>;
  format: Scalars['String']['input'];
}>;


export type GetDatasetSchemaUpdatesSubscription = { __typename?: 'Subscription', getDatasetSchemaUpdates: { __typename?: 'DatasetSchema', schema?: any | null } };

export type GetRunsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetRunsSubscription = { __typename?: 'Subscription', getRuns: { __typename?: 'Runs', engineInProgress: boolean, runs: Array<{ __typename?: 'Run', status: string, createdAt: string, updatedAt: string, stepIds: string, initiatedBy?: string | null, name?: string | null, description?: string | null, atStep?: number | null, totalSteps?: number | null, id: string, displayId?: string | null, runSettings: { __typename?: 'RunSettings', inputId: string, organizationId: string, workflowId: string, settingsNameAndVersion: string, runAttemptId: string } }> } };

export type GetTransformedRawParquetSubscriptionVariables = Exact<{
  datasetName: Scalars['String']['input'];
  transformId: Scalars['String']['input'];
  folder: Scalars['String']['input'];
  runSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  comparedToRunSettingsJson?: InputMaybe<Scalars['JSON']['input']>;
  format: Scalars['String']['input'];
  params: Scalars['JSON']['input'];
}>;


export type GetTransformedRawParquetSubscription = { __typename?: 'Subscription', getTransformedRawParquet: { __typename?: 'TransformedParquetStatus', id: string, status: TransformStatusEnum, parquetData?: string | null, errorMessage?: string | null, parquetRowCount?: number | null } };

export type WebappNotificationsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WebappNotificationsSubscription = { __typename?: 'Subscription', webappNotifications: { __typename?: 'RunProgress', organizationId: string, inputId: string, settingsNameAndVersion: string, workflowId: string, runAttemptId: string, status: string, createdAt: string, updatedAt: string, stepIds: string, initiatedBy: string, name: string, description: string, atStep: number, totalSteps: number, engineInProgress: boolean } };


export const InvalidateMyTransformationCachesDocument = gql`
    mutation InvalidateMyTransformationCaches($runSettings: RunSettingsInput!) {
  invalidateMyTransformationCaches(runSettings: $runSettings)
}
    `;
export type InvalidateMyTransformationCachesMutationFn = Apollo.MutationFunction<InvalidateMyTransformationCachesMutation, InvalidateMyTransformationCachesMutationVariables>;

/**
 * __useInvalidateMyTransformationCachesMutation__
 *
 * To run a mutation, you first call `useInvalidateMyTransformationCachesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvalidateMyTransformationCachesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invalidateMyTransformationCachesMutation, { data, loading, error }] = useInvalidateMyTransformationCachesMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useInvalidateMyTransformationCachesMutation(baseOptions?: Apollo.MutationHookOptions<InvalidateMyTransformationCachesMutation, InvalidateMyTransformationCachesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvalidateMyTransformationCachesMutation, InvalidateMyTransformationCachesMutationVariables>(InvalidateMyTransformationCachesDocument, options);
      }
export type InvalidateMyTransformationCachesMutationHookResult = ReturnType<typeof useInvalidateMyTransformationCachesMutation>;
export type InvalidateMyTransformationCachesMutationResult = Apollo.MutationResult<InvalidateMyTransformationCachesMutation>;
export type InvalidateMyTransformationCachesMutationOptions = Apollo.BaseMutationOptions<InvalidateMyTransformationCachesMutation, InvalidateMyTransformationCachesMutationVariables>;
export const PrepareMyHelpArticleUploadDocument = gql`
    mutation PrepareMyHelpArticleUpload($input: PrepareHelpArticleUploadInput!) {
  prepareMyHelpArticleUpload(input: $input) {
    uploadId
    expiresAt
    targets {
      filename
      mediaType
      url
      requiresAuth
      checksumSha256
    }
  }
}
    `;
export type PrepareMyHelpArticleUploadMutationFn = Apollo.MutationFunction<PrepareMyHelpArticleUploadMutation, PrepareMyHelpArticleUploadMutationVariables>;

/**
 * __usePrepareMyHelpArticleUploadMutation__
 *
 * To run a mutation, you first call `usePrepareMyHelpArticleUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareMyHelpArticleUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareMyHelpArticleUploadMutation, { data, loading, error }] = usePrepareMyHelpArticleUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareMyHelpArticleUploadMutation(baseOptions?: Apollo.MutationHookOptions<PrepareMyHelpArticleUploadMutation, PrepareMyHelpArticleUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareMyHelpArticleUploadMutation, PrepareMyHelpArticleUploadMutationVariables>(PrepareMyHelpArticleUploadDocument, options);
      }
export type PrepareMyHelpArticleUploadMutationHookResult = ReturnType<typeof usePrepareMyHelpArticleUploadMutation>;
export type PrepareMyHelpArticleUploadMutationResult = Apollo.MutationResult<PrepareMyHelpArticleUploadMutation>;
export type PrepareMyHelpArticleUploadMutationOptions = Apollo.BaseMutationOptions<PrepareMyHelpArticleUploadMutation, PrepareMyHelpArticleUploadMutationVariables>;
export const PublishMyHelpArticleDocument = gql`
    mutation PublishMyHelpArticle($uploadId: ID!) {
  publishMyHelpArticle(uploadId: $uploadId) {
    article {
      slug
      title
      summary
      category
      markdown
      updatedAt
      assets {
        filename
        mediaType
        url
      }
    }
  }
}
    `;
export type PublishMyHelpArticleMutationFn = Apollo.MutationFunction<PublishMyHelpArticleMutation, PublishMyHelpArticleMutationVariables>;

/**
 * __usePublishMyHelpArticleMutation__
 *
 * To run a mutation, you first call `usePublishMyHelpArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishMyHelpArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishMyHelpArticleMutation, { data, loading, error }] = usePublishMyHelpArticleMutation({
 *   variables: {
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function usePublishMyHelpArticleMutation(baseOptions?: Apollo.MutationHookOptions<PublishMyHelpArticleMutation, PublishMyHelpArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishMyHelpArticleMutation, PublishMyHelpArticleMutationVariables>(PublishMyHelpArticleDocument, options);
      }
export type PublishMyHelpArticleMutationHookResult = ReturnType<typeof usePublishMyHelpArticleMutation>;
export type PublishMyHelpArticleMutationResult = Apollo.MutationResult<PublishMyHelpArticleMutation>;
export type PublishMyHelpArticleMutationOptions = Apollo.BaseMutationOptions<PublishMyHelpArticleMutation, PublishMyHelpArticleMutationVariables>;
export const SetMyRunNameDocument = gql`
    mutation SetMyRunName($runSettings: RunSettingsInput!, $name: String!) {
  setMyRunName(runSettings: $runSettings, name: $name)
}
    `;
export type SetMyRunNameMutationFn = Apollo.MutationFunction<SetMyRunNameMutation, SetMyRunNameMutationVariables>;

/**
 * __useSetMyRunNameMutation__
 *
 * To run a mutation, you first call `useSetMyRunNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyRunNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyRunNameMutation, { data, loading, error }] = useSetMyRunNameMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetMyRunNameMutation(baseOptions?: Apollo.MutationHookOptions<SetMyRunNameMutation, SetMyRunNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyRunNameMutation, SetMyRunNameMutationVariables>(SetMyRunNameDocument, options);
      }
export type SetMyRunNameMutationHookResult = ReturnType<typeof useSetMyRunNameMutation>;
export type SetMyRunNameMutationResult = Apollo.MutationResult<SetMyRunNameMutation>;
export type SetMyRunNameMutationOptions = Apollo.BaseMutationOptions<SetMyRunNameMutation, SetMyRunNameMutationVariables>;
export const UnpublishMyHelpArticleDocument = gql`
    mutation UnpublishMyHelpArticle($slug: String!) {
  unpublishMyHelpArticle(slug: $slug)
}
    `;
export type UnpublishMyHelpArticleMutationFn = Apollo.MutationFunction<UnpublishMyHelpArticleMutation, UnpublishMyHelpArticleMutationVariables>;

/**
 * __useUnpublishMyHelpArticleMutation__
 *
 * To run a mutation, you first call `useUnpublishMyHelpArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishMyHelpArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishMyHelpArticleMutation, { data, loading, error }] = useUnpublishMyHelpArticleMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUnpublishMyHelpArticleMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishMyHelpArticleMutation, UnpublishMyHelpArticleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishMyHelpArticleMutation, UnpublishMyHelpArticleMutationVariables>(UnpublishMyHelpArticleDocument, options);
      }
export type UnpublishMyHelpArticleMutationHookResult = ReturnType<typeof useUnpublishMyHelpArticleMutation>;
export type UnpublishMyHelpArticleMutationResult = Apollo.MutationResult<UnpublishMyHelpArticleMutation>;
export type UnpublishMyHelpArticleMutationOptions = Apollo.BaseMutationOptions<UnpublishMyHelpArticleMutation, UnpublishMyHelpArticleMutationVariables>;
export const GetExportCsvDownloadUrlDocument = gql`
    query GetExportCsvDownloadUrl($datasetName: String!, $transformId: String!, $folder: String!, $runSettingsJson: JSON, $comparedToRunSettingsJson: JSON, $params: JSON!, $measure: String, $excludeDetailRows: Boolean!, $sortColumn: String, $sortDirection: String, $sortConfig: JSON, $downloadFilename: String) {
  getExportCsvDownloadUrl(
    datasetName: $datasetName
    transformId: $transformId
    folder: $folder
    runSettingsJson: $runSettingsJson
    comparedToRunSettingsJson: $comparedToRunSettingsJson
    params: $params
    measure: $measure
    excludeDetailRows: $excludeDetailRows
    sortColumn: $sortColumn
    sortDirection: $sortDirection
    sortConfig: $sortConfig
    downloadFilename: $downloadFilename
  ) {
    downloadUrl
  }
}
    `;

/**
 * __useGetExportCsvDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetExportCsvDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExportCsvDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExportCsvDownloadUrlQuery({
 *   variables: {
 *      datasetName: // value for 'datasetName'
 *      transformId: // value for 'transformId'
 *      folder: // value for 'folder'
 *      runSettingsJson: // value for 'runSettingsJson'
 *      comparedToRunSettingsJson: // value for 'comparedToRunSettingsJson'
 *      params: // value for 'params'
 *      measure: // value for 'measure'
 *      excludeDetailRows: // value for 'excludeDetailRows'
 *      sortColumn: // value for 'sortColumn'
 *      sortDirection: // value for 'sortDirection'
 *      sortConfig: // value for 'sortConfig'
 *      downloadFilename: // value for 'downloadFilename'
 *   },
 * });
 */
export function useGetExportCsvDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetExportCsvDownloadUrlQuery, GetExportCsvDownloadUrlQueryVariables> & ({ variables: GetExportCsvDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExportCsvDownloadUrlQuery, GetExportCsvDownloadUrlQueryVariables>(GetExportCsvDownloadUrlDocument, options);
      }
export function useGetExportCsvDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExportCsvDownloadUrlQuery, GetExportCsvDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExportCsvDownloadUrlQuery, GetExportCsvDownloadUrlQueryVariables>(GetExportCsvDownloadUrlDocument, options);
        }
export function useGetExportCsvDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExportCsvDownloadUrlQuery, GetExportCsvDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExportCsvDownloadUrlQuery, GetExportCsvDownloadUrlQueryVariables>(GetExportCsvDownloadUrlDocument, options);
        }
export type GetExportCsvDownloadUrlQueryHookResult = ReturnType<typeof useGetExportCsvDownloadUrlQuery>;
export type GetExportCsvDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetExportCsvDownloadUrlLazyQuery>;
export type GetExportCsvDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetExportCsvDownloadUrlSuspenseQuery>;
export type GetExportCsvDownloadUrlQueryResult = Apollo.QueryResult<GetExportCsvDownloadUrlQuery, GetExportCsvDownloadUrlQueryVariables>;
export const GetMatrixSortKeysDocument = gql`
    query GetMatrixSortKeys($datasetName: String!, $transformId: String!, $folder: String!, $runSettingsJson: JSON, $comparedToRunSettingsJson: JSON, $params: JSON!, $measure: String!) {
  getMatrixSortKeys(
    datasetName: $datasetName
    transformId: $transformId
    folder: $folder
    runSettingsJson: $runSettingsJson
    comparedToRunSettingsJson: $comparedToRunSettingsJson
    params: $params
    measure: $measure
  )
}
    `;

/**
 * __useGetMatrixSortKeysQuery__
 *
 * To run a query within a React component, call `useGetMatrixSortKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatrixSortKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatrixSortKeysQuery({
 *   variables: {
 *      datasetName: // value for 'datasetName'
 *      transformId: // value for 'transformId'
 *      folder: // value for 'folder'
 *      runSettingsJson: // value for 'runSettingsJson'
 *      comparedToRunSettingsJson: // value for 'comparedToRunSettingsJson'
 *      params: // value for 'params'
 *      measure: // value for 'measure'
 *   },
 * });
 */
export function useGetMatrixSortKeysQuery(baseOptions: Apollo.QueryHookOptions<GetMatrixSortKeysQuery, GetMatrixSortKeysQueryVariables> & ({ variables: GetMatrixSortKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatrixSortKeysQuery, GetMatrixSortKeysQueryVariables>(GetMatrixSortKeysDocument, options);
      }
export function useGetMatrixSortKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatrixSortKeysQuery, GetMatrixSortKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatrixSortKeysQuery, GetMatrixSortKeysQueryVariables>(GetMatrixSortKeysDocument, options);
        }
export function useGetMatrixSortKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMatrixSortKeysQuery, GetMatrixSortKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMatrixSortKeysQuery, GetMatrixSortKeysQueryVariables>(GetMatrixSortKeysDocument, options);
        }
export type GetMatrixSortKeysQueryHookResult = ReturnType<typeof useGetMatrixSortKeysQuery>;
export type GetMatrixSortKeysLazyQueryHookResult = ReturnType<typeof useGetMatrixSortKeysLazyQuery>;
export type GetMatrixSortKeysSuspenseQueryHookResult = ReturnType<typeof useGetMatrixSortKeysSuspenseQuery>;
export type GetMatrixSortKeysQueryResult = Apollo.QueryResult<GetMatrixSortKeysQuery, GetMatrixSortKeysQueryVariables>;
export const GetMyRunTrendSeriesDocument = gql`
    query GetMyRunTrendSeries {
  getMyRunTrendSeries {
    month
    runCount
    inventoryUnits
    unfulfilledUnits
    excessUnits
    inventoryRunCount
    unfulfilledRunCount
    excessRunCount
  }
}
    `;

/**
 * __useGetMyRunTrendSeriesQuery__
 *
 * To run a query within a React component, call `useGetMyRunTrendSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRunTrendSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRunTrendSeriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyRunTrendSeriesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRunTrendSeriesQuery, GetMyRunTrendSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRunTrendSeriesQuery, GetMyRunTrendSeriesQueryVariables>(GetMyRunTrendSeriesDocument, options);
      }
export function useGetMyRunTrendSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRunTrendSeriesQuery, GetMyRunTrendSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRunTrendSeriesQuery, GetMyRunTrendSeriesQueryVariables>(GetMyRunTrendSeriesDocument, options);
        }
export function useGetMyRunTrendSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRunTrendSeriesQuery, GetMyRunTrendSeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRunTrendSeriesQuery, GetMyRunTrendSeriesQueryVariables>(GetMyRunTrendSeriesDocument, options);
        }
export type GetMyRunTrendSeriesQueryHookResult = ReturnType<typeof useGetMyRunTrendSeriesQuery>;
export type GetMyRunTrendSeriesLazyQueryHookResult = ReturnType<typeof useGetMyRunTrendSeriesLazyQuery>;
export type GetMyRunTrendSeriesSuspenseQueryHookResult = ReturnType<typeof useGetMyRunTrendSeriesSuspenseQuery>;
export type GetMyRunTrendSeriesQueryResult = Apollo.QueryResult<GetMyRunTrendSeriesQuery, GetMyRunTrendSeriesQueryVariables>;
export const GetRawParquetDocument = gql`
    query GetRawParquet($datasetName: String!, $folder: String!, $setId: String, $format: String!) {
  getRawParquet(
    datasetName: $datasetName
    folder: $folder
    setId: $setId
    format: $format
  )
}
    `;

/**
 * __useGetRawParquetQuery__
 *
 * To run a query within a React component, call `useGetRawParquetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRawParquetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRawParquetQuery({
 *   variables: {
 *      datasetName: // value for 'datasetName'
 *      folder: // value for 'folder'
 *      setId: // value for 'setId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useGetRawParquetQuery(baseOptions: Apollo.QueryHookOptions<GetRawParquetQuery, GetRawParquetQueryVariables> & ({ variables: GetRawParquetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRawParquetQuery, GetRawParquetQueryVariables>(GetRawParquetDocument, options);
      }
export function useGetRawParquetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRawParquetQuery, GetRawParquetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRawParquetQuery, GetRawParquetQueryVariables>(GetRawParquetDocument, options);
        }
export function useGetRawParquetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRawParquetQuery, GetRawParquetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRawParquetQuery, GetRawParquetQueryVariables>(GetRawParquetDocument, options);
        }
export type GetRawParquetQueryHookResult = ReturnType<typeof useGetRawParquetQuery>;
export type GetRawParquetLazyQueryHookResult = ReturnType<typeof useGetRawParquetLazyQuery>;
export type GetRawParquetSuspenseQueryHookResult = ReturnType<typeof useGetRawParquetSuspenseQuery>;
export type GetRawParquetQueryResult = Apollo.QueryResult<GetRawParquetQuery, GetRawParquetQueryVariables>;
export const GetTransformedParquetDownloadUrlDocument = gql`
    query GetTransformedParquetDownloadUrl($datasetName: String!, $transformId: String!, $folder: String!, $runSettingsJson: JSON, $comparedToRunSettingsJson: JSON, $params: JSON!) {
  getTransformedParquetDownloadUrl(
    datasetName: $datasetName
    transformId: $transformId
    folder: $folder
    runSettingsJson: $runSettingsJson
    comparedToRunSettingsJson: $comparedToRunSettingsJson
    params: $params
  ) {
    downloadUrl
    parquetRowCount
  }
}
    `;

/**
 * __useGetTransformedParquetDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetTransformedParquetDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransformedParquetDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransformedParquetDownloadUrlQuery({
 *   variables: {
 *      datasetName: // value for 'datasetName'
 *      transformId: // value for 'transformId'
 *      folder: // value for 'folder'
 *      runSettingsJson: // value for 'runSettingsJson'
 *      comparedToRunSettingsJson: // value for 'comparedToRunSettingsJson'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTransformedParquetDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetTransformedParquetDownloadUrlQuery, GetTransformedParquetDownloadUrlQueryVariables> & ({ variables: GetTransformedParquetDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransformedParquetDownloadUrlQuery, GetTransformedParquetDownloadUrlQueryVariables>(GetTransformedParquetDownloadUrlDocument, options);
      }
export function useGetTransformedParquetDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransformedParquetDownloadUrlQuery, GetTransformedParquetDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransformedParquetDownloadUrlQuery, GetTransformedParquetDownloadUrlQueryVariables>(GetTransformedParquetDownloadUrlDocument, options);
        }
export function useGetTransformedParquetDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransformedParquetDownloadUrlQuery, GetTransformedParquetDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransformedParquetDownloadUrlQuery, GetTransformedParquetDownloadUrlQueryVariables>(GetTransformedParquetDownloadUrlDocument, options);
        }
export type GetTransformedParquetDownloadUrlQueryHookResult = ReturnType<typeof useGetTransformedParquetDownloadUrlQuery>;
export type GetTransformedParquetDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetTransformedParquetDownloadUrlLazyQuery>;
export type GetTransformedParquetDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetTransformedParquetDownloadUrlSuspenseQuery>;
export type GetTransformedParquetDownloadUrlQueryResult = Apollo.QueryResult<GetTransformedParquetDownloadUrlQuery, GetTransformedParquetDownloadUrlQueryVariables>;
export const MyHelpArticleDocument = gql`
    query MyHelpArticle($slug: String!) {
  myHelpArticle(slug: $slug) {
    slug
    title
    summary
    category
    markdown
    updatedAt
    assets {
      filename
      mediaType
      url
    }
  }
}
    `;

/**
 * __useMyHelpArticleQuery__
 *
 * To run a query within a React component, call `useMyHelpArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHelpArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHelpArticleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useMyHelpArticleQuery(baseOptions: Apollo.QueryHookOptions<MyHelpArticleQuery, MyHelpArticleQueryVariables> & ({ variables: MyHelpArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyHelpArticleQuery, MyHelpArticleQueryVariables>(MyHelpArticleDocument, options);
      }
export function useMyHelpArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyHelpArticleQuery, MyHelpArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyHelpArticleQuery, MyHelpArticleQueryVariables>(MyHelpArticleDocument, options);
        }
export function useMyHelpArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyHelpArticleQuery, MyHelpArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyHelpArticleQuery, MyHelpArticleQueryVariables>(MyHelpArticleDocument, options);
        }
export type MyHelpArticleQueryHookResult = ReturnType<typeof useMyHelpArticleQuery>;
export type MyHelpArticleLazyQueryHookResult = ReturnType<typeof useMyHelpArticleLazyQuery>;
export type MyHelpArticleSuspenseQueryHookResult = ReturnType<typeof useMyHelpArticleSuspenseQuery>;
export type MyHelpArticleQueryResult = Apollo.QueryResult<MyHelpArticleQuery, MyHelpArticleQueryVariables>;
export const MyHelpArticlesDocument = gql`
    query MyHelpArticles {
  myHelpArticles {
    slug
    title
    summary
    category
    updatedAt
  }
}
    `;

/**
 * __useMyHelpArticlesQuery__
 *
 * To run a query within a React component, call `useMyHelpArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHelpArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHelpArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyHelpArticlesQuery(baseOptions?: Apollo.QueryHookOptions<MyHelpArticlesQuery, MyHelpArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyHelpArticlesQuery, MyHelpArticlesQueryVariables>(MyHelpArticlesDocument, options);
      }
export function useMyHelpArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyHelpArticlesQuery, MyHelpArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyHelpArticlesQuery, MyHelpArticlesQueryVariables>(MyHelpArticlesDocument, options);
        }
export function useMyHelpArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyHelpArticlesQuery, MyHelpArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyHelpArticlesQuery, MyHelpArticlesQueryVariables>(MyHelpArticlesDocument, options);
        }
export type MyHelpArticlesQueryHookResult = ReturnType<typeof useMyHelpArticlesQuery>;
export type MyHelpArticlesLazyQueryHookResult = ReturnType<typeof useMyHelpArticlesLazyQuery>;
export type MyHelpArticlesSuspenseQueryHookResult = ReturnType<typeof useMyHelpArticlesSuspenseQuery>;
export type MyHelpArticlesQueryResult = Apollo.QueryResult<MyHelpArticlesQuery, MyHelpArticlesQueryVariables>;
export const GetDatasetSchemaUpdatesDocument = gql`
    subscription GetDatasetSchemaUpdates($datasetName: String!, $folder: String!, $lockedSetId: String, $comparedToSetId: String, $format: String!) {
  getDatasetSchemaUpdates(
    datasetName: $datasetName
    folder: $folder
    lockedSetId: $lockedSetId
    comparedToSetId: $comparedToSetId
    format: $format
  ) {
    schema
  }
}
    `;

/**
 * __useGetDatasetSchemaUpdatesSubscription__
 *
 * To run a query within a React component, call `useGetDatasetSchemaUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetSchemaUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetSchemaUpdatesSubscription({
 *   variables: {
 *      datasetName: // value for 'datasetName'
 *      folder: // value for 'folder'
 *      lockedSetId: // value for 'lockedSetId'
 *      comparedToSetId: // value for 'comparedToSetId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useGetDatasetSchemaUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetDatasetSchemaUpdatesSubscription, GetDatasetSchemaUpdatesSubscriptionVariables> & ({ variables: GetDatasetSchemaUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDatasetSchemaUpdatesSubscription, GetDatasetSchemaUpdatesSubscriptionVariables>(GetDatasetSchemaUpdatesDocument, options);
      }
export type GetDatasetSchemaUpdatesSubscriptionHookResult = ReturnType<typeof useGetDatasetSchemaUpdatesSubscription>;
export type GetDatasetSchemaUpdatesSubscriptionResult = Apollo.SubscriptionResult<GetDatasetSchemaUpdatesSubscription>;
export const GetRunsDocument = gql`
    subscription GetRuns {
  getRuns {
    runs {
      runSettings {
        inputId
        organizationId
        workflowId
        settingsNameAndVersion
        runAttemptId
      }
      status
      createdAt
      updatedAt
      stepIds
      initiatedBy
      name
      description
      atStep
      totalSteps
      id
      displayId
    }
    engineInProgress
  }
}
    `;

/**
 * __useGetRunsSubscription__
 *
 * To run a query within a React component, call `useGetRunsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetRunsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetRunsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetRunsSubscription, GetRunsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetRunsSubscription, GetRunsSubscriptionVariables>(GetRunsDocument, options);
      }
export type GetRunsSubscriptionHookResult = ReturnType<typeof useGetRunsSubscription>;
export type GetRunsSubscriptionResult = Apollo.SubscriptionResult<GetRunsSubscription>;
export const GetTransformedRawParquetDocument = gql`
    subscription GetTransformedRawParquet($datasetName: String!, $transformId: String!, $folder: String!, $runSettingsJson: JSON, $comparedToRunSettingsJson: JSON, $format: String!, $params: JSON!) {
  getTransformedRawParquet(
    datasetName: $datasetName
    transformId: $transformId
    folder: $folder
    runSettingsJson: $runSettingsJson
    comparedToRunSettingsJson: $comparedToRunSettingsJson
    format: $format
    params: $params
  ) {
    id
    status
    parquetData
    errorMessage
    parquetRowCount
  }
}
    `;

/**
 * __useGetTransformedRawParquetSubscription__
 *
 * To run a query within a React component, call `useGetTransformedRawParquetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetTransformedRawParquetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransformedRawParquetSubscription({
 *   variables: {
 *      datasetName: // value for 'datasetName'
 *      transformId: // value for 'transformId'
 *      folder: // value for 'folder'
 *      runSettingsJson: // value for 'runSettingsJson'
 *      comparedToRunSettingsJson: // value for 'comparedToRunSettingsJson'
 *      format: // value for 'format'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTransformedRawParquetSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetTransformedRawParquetSubscription, GetTransformedRawParquetSubscriptionVariables> & ({ variables: GetTransformedRawParquetSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetTransformedRawParquetSubscription, GetTransformedRawParquetSubscriptionVariables>(GetTransformedRawParquetDocument, options);
      }
export type GetTransformedRawParquetSubscriptionHookResult = ReturnType<typeof useGetTransformedRawParquetSubscription>;
export type GetTransformedRawParquetSubscriptionResult = Apollo.SubscriptionResult<GetTransformedRawParquetSubscription>;
export const WebappNotificationsDocument = gql`
    subscription WebappNotifications {
  webappNotifications {
    organizationId
    inputId
    settingsNameAndVersion
    workflowId
    runAttemptId
    status
    createdAt
    updatedAt
    stepIds
    initiatedBy
    name
    description
    atStep
    totalSteps
    engineInProgress
  }
}
    `;

/**
 * __useWebappNotificationsSubscription__
 *
 * To run a query within a React component, call `useWebappNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWebappNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebappNotificationsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWebappNotificationsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WebappNotificationsSubscription, WebappNotificationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WebappNotificationsSubscription, WebappNotificationsSubscriptionVariables>(WebappNotificationsDocument, options);
      }
export type WebappNotificationsSubscriptionHookResult = ReturnType<typeof useWebappNotificationsSubscription>;
export type WebappNotificationsSubscriptionResult = Apollo.SubscriptionResult<WebappNotificationsSubscription>;
export const namedOperations = {
  Query: {
    GetExportCsvDownloadUrl: 'GetExportCsvDownloadUrl',
    GetMatrixSortKeys: 'GetMatrixSortKeys',
    GetMyRunTrendSeries: 'GetMyRunTrendSeries',
    GetRawParquet: 'GetRawParquet',
    GetTransformedParquetDownloadUrl: 'GetTransformedParquetDownloadUrl',
    MyHelpArticle: 'MyHelpArticle',
    MyHelpArticles: 'MyHelpArticles'
  },
  Mutation: {
    InvalidateMyTransformationCaches: 'InvalidateMyTransformationCaches',
    PrepareMyHelpArticleUpload: 'PrepareMyHelpArticleUpload',
    PublishMyHelpArticle: 'PublishMyHelpArticle',
    SetMyRunName: 'SetMyRunName',
    UnpublishMyHelpArticle: 'UnpublishMyHelpArticle'
  },
  Subscription: {
    GetDatasetSchemaUpdates: 'GetDatasetSchemaUpdates',
    GetRuns: 'GetRuns',
    GetTransformedRawParquet: 'GetTransformedRawParquet',
    WebappNotifications: 'WebappNotifications'
  }
}